module.exports = __webpack_public_path__ + "static/media/mc.a1760782.svg";